/* Shared Yotpo "(N Reviews" text rewrite (C6, extends the T4b pattern).
   Replaces the legacy per-section 1ms setInterval polls. One deferred asset
   serves the homepage carousel_2 sections and the collection grid; the
   replacement string differs per context and is read from the script tag's
   data-replacement attribute (")" on the homepage, "" on collections).
   MutationObserver-driven; observes for the same 6s window the legacy poll
   covered (Yotpo populates progressively), then disconnects and applies the .yotpo-bottomline flex styling exactly as the
   old timers did. Window guard: first tag on the page wins. */
(function () {
  if (window.__yotpoReviewTextDone) return;
  window.__yotpoReviewTextDone = true;
  var tag = document.currentScript;
  var replacement = (tag && tag.getAttribute('data-replacement')) || '';

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  onReady(function () {
    var observer = null;
    var done = false;

    function rewrite() {
      var changed = false;
      document.querySelectorAll('.text-m').forEach(function (el) {
        var v = el.textContent;
        if (v.indexOf('Review') !== -1) {
          el.textContent = v.replace(' Review', replacement).replace('s', '');
          changed = true;
        }
      });
      return changed;
    }

    function finish() {
      if (done) return;
      done = true;
      if (observer) observer.disconnect();
    }

    /* The legacy 1ms poll rewrote every .text-m that appeared within its 6s
       window; Yotpo populates cards progressively, so we keep observing for
       the full window instead of stopping at the first successful rewrite. */
    rewrite();
    if (window.MutationObserver) {
      observer = new MutationObserver(function () {
        rewrite();
      });
      observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    }

    setTimeout(function () {
      finish();
      document.querySelectorAll('.yotpo-bottomline').forEach(function (el) {
        el.style.display = 'flex';
        el.style.alignItems = 'center';
      });
    }, 6000);
  });
})();
